import { Component, OnInit } from "@angular/core";
import { TramiteStepperService } from "../../services/tramite-stepper.service";
import { LoadingStateService } from "../../services/loading-state.service";
import { ROUTING_TRAMITE_PENSION } from "@constants/url.constant";
import { NavigationEnd, Router } from "@angular/router";

@Component({
  selector: "app-tramite-pension-stepper",
  templateUrl: "./tramite-pension-stepper.component.html",
  styleUrls: ["./tramite-pension-stepper.component.scss"],
  standalone: false,
})
export class TramitePensionStepperComponent implements OnInit {
  step: number = 0;
  isResponsive: boolean = false;
  titleCurrentStepResponsive: string = "";
  currentStepResponsive: string = "";
  isStepperVisible: boolean = true;

  constructor(
    private readonly tramiteStepper: TramiteStepperService,
    private readonly router: Router,
    private readonly loadingStateService: LoadingStateService
  ) { }

  ngOnInit(): void {
    this.isResponsive = window.innerWidth < 840 ;
    this.getCurrentStep();

    // Suscribirse al estado de carga global
    this.loadingStateService.isLoading$.subscribe((isLoading) => {
      this.isStepperVisible = !isLoading;
    });

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // Verificar si la URL actual es la que quieres redirigir
        if (event.url === '/pensions') {
          this.router.navigate(['/pensions/tramite-pensiones']); // Redirecciona a la ruta base
        }
      }
    });
  }

  public steps: any[] = [
    {
      status: "pending",
      title: "Paso 1",
      titleResponsive: "Validación de identidad",
      subtitle: "Validación de identidad",
      path: ROUTING_TRAMITE_PENSION.SEGURIDAD,
      url: "/pensions/tramite-pensiones/solicitud/seguridad/keys",
    },
    {
      status: "pending",
      title: "Paso 2",
      titleResponsive: "Tu información",
      subtitle: "Tu información",
      stepInfo: "Presiona estas secciones para navegar por la página",     
      path: ROUTING_TRAMITE_PENSION.DATOS_PERSONALES,
      url: "/pensions/tramite-pensiones/solicitud/datos-personales",
    },
    {
      status: "pending",
      title: "Paso 3",
      titleResponsive: "Antecedentes pensión",
      subtitle: "Antecedentes pensión",
      path: ROUTING_TRAMITE_PENSION.VIA_PAGO,
      url: "/pensions/tramite-pensiones/solicitud/via-pago",
    },
    {
      status: "pending",
      title: "Paso 4",
      titleResponsive: "Vía de pago",
      subtitle: "Vía de pago",
      path: ROUTING_TRAMITE_PENSION.VIA_PAGO,
      url: "/pensions/tramite-pensiones/solicitud/via-pago",
    },
    {
      status: "pending",
      title: "Paso 5",
      titleResponsive: "Documentación",
      subtitle: "Documentación",
      stepInfo: "Por favor, carga tus documentos en el orden solicitado.",
      nav_index: [],
      path: ROUTING_TRAMITE_PENSION.CARGA_DOCUMENTOS,
      url: "/pensions/tramite-pensiones/solicitud/carga-documentos",
    },
    {
      status: "Pending",
      title: "Paso 6",
      titleResponsive: "Confirmación",
      subtitle: "Confirmación",
      stepInfo: "Presiona estas secciones para navegar por la página",      
      path: ROUTING_TRAMITE_PENSION.CONFIRMAR_DATOS,
      url: "/pensions/tramite-pensiones/solicitud/confirmar-datos",
    },
  ];

  getCurrentStep() {
    console.log("Current step before subscription:", this.step);
    this.tramiteStepper.stepCurrent.subscribe((response) => {
      this.step = response;
      const totalSteps = this.steps.length;
      this.steps.forEach((step, index) => {
        if (index + 1 < this.step) step.status = "complete";
        else if (index + 1 == this.step) {
          step.status = "current";
          this.titleCurrentStepResponsive = step.titleResponsive;
          this.currentStepResponsive = `Paso ${index + 1} de ${totalSteps}`;
        }
        else step.status = "pending";        
      });      
    });
  }

  calculateProgress(): number {
    const completedSteps = this.steps.filter(step => step.status === 'current' || step.status === 'complete').length;    
    return completedSteps / this.steps.length; // Retorna un valor entre 0 y 1
  }
}
